export default __webpack_public_path__ + "static/media/confirm-export.504169c9.svg";